export const IDLE = 'IDLE';
export const GUARDANDO = 'GUARDANDO';
export const GUARDADO = 'GUARDADO';
export const ERROR = 'ERROR';
export const CON_CAMBIOS = 'CON_CAMBIOS';
export const SIN_CAMBIOS = 'SIN_CAMBIOS';
